import { render } from "./excursionList.vue?vue&type=template&id=5c28c202&scoped=true"
import script from "./excursionList.vue?vue&type=script&lang=js"
export * from "./excursionList.vue?vue&type=script&lang=js"

import "./excursionList.vue?vue&type=style&index=0&id=5c28c202&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c28c202"]])

export default __exports__